import React from 'react';
import { connect } from 'react-redux';
import UserModal from '../../components/MenuItems/Admin/UserModal';
import ConfirmationModal from '../../components/Modals/ConfirmationModal';
import { MODALS } from '../../constants';

import { getRoles } from '../../selectors/admin';
import { aRoleInit, aUserAdd, aUserEditInfo, aUserEditRoles } from '../../reducers';

const mapToProps = (state) => ({
  roles: getRoles(state),
});
const actionsToProps = (dispatch) => ({
  getRoles: (payload) => dispatch(aRoleInit(payload)),
  addUser: (payload) => dispatch(aUserAdd(payload)),
  userEditRoles: (payload) => dispatch(aUserEditRoles(payload)),
  userEditInfo: (payload) => dispatch(aUserEditInfo(payload)),
});
/**
 * UserModals
 *
 * @param {any} props
 * @param {Array} props.roles All roles data
 * @param {Function} props.getRoles API action to get roles data
 * @param {Function} props.addUser API action to add new user
 * @param {Function} props.userEditRoles API action to edit user's roles
 * @param {Function} props.userEditInfo API action to edit user info
 * @function
 * @returns {view|null}
 */
const UserModals = (props) => {
  switch (props.activeModal) {
    case MODALS.USER_ADD:
      return (
        <UserModal
          roles={props.roles}
          add
          heading="Add user"
          save={props.addUser}
          setOpenModal={props.setOpenModal}
          getRoles={props.getRoles}
        />
      );
    case MODALS.USER_CONFIRM:
      return (
        <ConfirmationModal
          modalData={{
            heading: props.operation.heading,
            title: props.operation.title,
            additionalMessages: [props.operationUser.username],
          }}
          cancel={props.closeModal}
          confirmation={props.operation.confirmation}
        />
      );
    case MODALS.USER_EDIT:
      return (
        <UserModal
          roles={props.roles}
          user={props.operationUser}
          editRoles
          getRoles={props.getRoles}
          heading="Edit user roles"
          save={props.userEditRoles}
          setOpenModal={props.setOpenModal}
        />
      );
    case MODALS.USER_INFO_EDIT:
      return (
        <UserModal
          roles={props.roles}
          user={props.operationUser}
          editInfo
          heading="Edit user"
          save={props.userEditInfo}
          setOpenModal={props.setOpenModal}
        />
      );

    default:
      return null;
  }
};

export default connect(mapToProps, actionsToProps)(UserModals);
